import { Flex, Text } from "@radix-ui/themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { cn, fetcher } from "@/lib/utils";
import { navigationMenuTriggerStyle } from "../ui/navigation-menu";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Auction } from "@prisma/client";
import useSWR from "swr";

export default function AuctionsTab({
  navButtonStyle,
}: {
  navButtonStyle: string;
}) {
  const { data: recentAuction } = useSWR<Auction[]>('/api/auctions/recent?limit=2', fetcher);

  const { data: hasPastAuctions } = useSWR<boolean>('/api/auctions/past', fetcher);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Flex
          align="center"
          className={cn(navigationMenuTriggerStyle(), navButtonStyle, "gap-1")}
        >
          <Text>Auctions</Text>
          <ChevronDownIcon />
        </Flex>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {recentAuction && recentAuction.length > 0 && (
          recentAuction.length > 1 ? (
            <DropdownMenuSub>
              <DropdownMenuSubTrigger chevronDirection="none">
                <Link href={`/auctions/${recentAuction[recentAuction.length - 1].id}`} className="w-full" prefetch={false}>
                  <Text className="truncate">Current Auction</Text>
                </Link>
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                {recentAuction.map((auction: Auction, index: number) => (
                  <DropdownMenuItem key={auction.id} asChild className="max-w-[200px]">
                    <Link href={`/auctions/${auction.id}`} className="w-full" prefetch={false}>
                      <Text className="truncate">{auction.title} this is a super long title</Text>
                    </Link>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          ) : (
            <DropdownMenuItem asChild>
              <Link href={`/auctions/${recentAuction[recentAuction.length - 1].id}`} className="max-w-[200px] w-full" prefetch={false}>
                Current Auction
              </Link>
            </DropdownMenuItem>
          )
        )}
        <DropdownMenuItem asChild disabled={!hasPastAuctions}>
          <Link href={"/auctions/all"} className="block w-full" prefetch={false}>
            <Text className="truncate">Past Auctions</Text>
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu >
  );
}
